module.exports = __webpack_public_path__ + "static/images/monet/route_progress_bar_return.png";